import _slicedToArray from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
export function mapSpaceToVar(spacingMap, size) {
  return size ? "var(".concat(spacingMap[size], ")") : undefined;
}
/**
 * Generate axis related logical properties
 * @param {string} cssRuleName Name of CSS rule
 * @param {string} shorthandPropName Name of the prop that contains spacing shorthand list
 * @returns {function} a function accepting a props
 */

export function injectSpacing(cssRuleName) {
  var shorthandPropName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'outerSpacing';

  /**
   * @param {Object} props a set of props which must contain the theme, and a spacing shorthand list under the `shorthandPropName` key
   * @returns {string} css axis related logical properties
   */
  return function (props) {
    var _a;

    var _ref = (_a = props[shorthandPropName]) !== null && _a !== void 0 ? _a : [],
        _ref2 = _slicedToArray(_ref, 4),
        blockStart = _ref2[0],
        inlineEnd = _ref2[1],
        blockEnd = _ref2[2],
        inlineStart = _ref2[3];

    var spacingMap = props.theme.responsive.spacing;
    var propertyEntries = [["".concat(cssRuleName, "-block-start"), mapSpaceToVar(spacingMap, blockStart)], ["".concat(cssRuleName, "-inline-end"), mapSpaceToVar(spacingMap, inlineEnd)], ["".concat(cssRuleName, "-block-end"), mapSpaceToVar(spacingMap, blockEnd)], ["".concat(cssRuleName, "-inline-start"), mapSpaceToVar(spacingMap, inlineStart)]];
    var rules = propertyEntries.filter(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          value = _ref4[1];

      return value;
    }).map(function (entry) {
      return "".concat(entry.join(': '), ";");
    });

    if (rules.length === 4) {
      return "".concat(cssRuleName, ": ").concat(propertyEntries.map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            value = _ref6[1];

        return value;
      }).join(' '), ";");
    }

    return rules.join('\n');
  };
}